import {
  ArrowDownUp,
  BookA,
  BookOpenText,
  Bot,
  BringToFront,
  CircleSlash,
  CloudLightningIcon,
  Cog,
  Cpu,
  Database,
  DatabaseZap,
  Fingerprint,
  FlaskConical,
  Frame,
  Infinity,
  Layers2,
  LetterText,
  Logs,
  Network,
  ScanEye,
  Shuffle,
  Waypoints,
  Wifi
} from "lucide-react"
import { PrincipleType } from "@/models/Principle"

const defaultIcon = Frame

const customIcons = {
  [PrincipleType.AI]: Bot,
  [PrincipleType.ALGORITHMS]: Waypoints,
  [PrincipleType.API]: Network,
  [PrincipleType.NULL_HANDLING]: CircleSlash,
  [PrincipleType.NAMING_CONVENTIONS]: BookA,
  [PrincipleType.CODE_STYLE]: LetterText,
  [PrincipleType.CONCURRENCY]: Shuffle,
  [PrincipleType.SECURITY]: Fingerprint,
  [PrincipleType.CACHING]: DatabaseZap,
  [PrincipleType.CI_CD]: Infinity,
  [PrincipleType.DOCUMENTATION]: BookOpenText,
  [PrincipleType.ERROR_HANDLING]: CloudLightningIcon,
  [PrincipleType.OBSERVABILITY]: ScanEye,
  [PrincipleType.DATABASE]: Database,
  [PrincipleType.MIGRATIONS]: BringToFront,
  [PrincipleType.TESTING]: FlaskConical,
  [PrincipleType.CONFIGURATIONS]: Cog,
  [PrincipleType.TEMPORAL]: ArrowDownUp,
  [PrincipleType.LOGGING]: Logs,
  [PrincipleType.PERFORMANCE_OPTIMIZATION]: Cpu,
  [PrincipleType.NETWORKING]: Wifi,
  [PrincipleType.NEST_JS]: Layers2,
  [PrincipleType.VUE]: Layers2,
  [PrincipleType.NEXT]: Layers2,
  [PrincipleType.ANGULAR]: Layers2,
  [PrincipleType.REACT]: Layers2,
  [PrincipleType.DBT]: Layers2,
  [PrincipleType.CELERY]: Layers2,
  [PrincipleType.PYTORCH]: Layers2,
  [PrincipleType.SPRING]: Layers2
}

export const CUSTOM_REVIEWER_TYPES = Object.values(PrincipleType).map((type) => ({
  type,
  icon: customIcons[type] || defaultIcon
}))
